import { queryOptions } from '@tanstack/react-query'
import { coreInstance } from './coreInstance'

const holidaysOnPeriod = (from: string, to: string) =>
  ['current-user', 'holidays', from, to] as const

const getCurrentUserHolidays = (from: string, to: string): Promise<string[]> =>
  coreInstance
    .get('/employee_holidays', {
      params: { from, to },
    })
    .then((response) => response.data.holidays)

export const currentUserHolidaysQuery = (from: string, to: string) =>
  queryOptions({
    queryKey: holidaysOnPeriod(from, to),
    queryFn: () => getCurrentUserHolidays(from, to),
    gcTime: Infinity,
    staleTime: Infinity,
  })
